// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"userVideoMessage_mainContainer__NyDE-","userImg":"userVideoMessage_userImg__2NC8f","messageContainer":"userVideoMessage_messageContainer__3l7AW"};